import FormattedMessage from 'I18n/components/FormattedMessage';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Text } from 'foundations-components/components/Text';
import { getLanguageNameFromCode } from '../../../utils/langUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TranslateTemplateTextFieldGroup(props) {
  return /*#__PURE__*/_jsx(AccordionItem, {
    title: /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-100",
      children: props.title
    }),
    marginBlockStart: "400",
    children: props.languages.map((lang, idx) => {
      const isPrimary = idx === 0;
      const onChange = e => props.onChange(lang, e.target.value);
      const value = props.values.get(lang, '');
      return /*#__PURE__*/_jsx(FormControl, {
        verticalSeparation: "flush",
        label: getLanguageNameFromCode(lang),
        labelTooltip: isPrimary ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.templateEditor.translateModal.primaryLanguageFieldTooltip"
        }) : null,
        children: /*#__PURE__*/_jsx(TextInput, {
          readOnly: isPrimary,
          onChange: onChange,
          value: value || ''
        })
      }, lang);
    })
  });
}